import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/style/main.scss";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from "./store";
import { Provider } from "react-redux";
import { WagmiConfig, createConfig, createStorage } from "wagmi";
import { configureChains } from "@wagmi/core";
import { base, sepolia, mainnet } from "@wagmi/core/chains";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";

var currentChain = sepolia;

if (Number(process.env.REACT_APP_L1_CHAIN_ID) === 1) {
  currentChain = mainnet;
}

export const jbc = {
  id: Number(process.env.REACT_APP_L1_CHAIN_ID),
  name: "JIBCHAIN L1",
  network: "JIBCHAIN L1",
  iconUrl: "https://",
  iconBackground: "#000000",
  nativeCurrency: {
    decimals: 18,
    name: "JBC",
    symbol: "JBC",
  },
  rpcUrls: {
    default: {
      http: [process.env.REACT_APP_L1_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: process.env.REACT_APP_L1_EXPLORER_URL,
    },
  },
};

export const pom = {
  id: Number(process.env.REACT_APP_L2_CHAIN_ID),
  name: "POM CHAIN",
  network: "POM CHAIN",
  iconUrl: "https://",
  iconBackground: "#000000",
  nativeCurrency: {
    decimals: 18,
    name: "POM",
    symbol: "POM",
  },
  rpcUrls: {
    default: {
      http: [process.env.REACT_APP_L2_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: process.env.REACT_APP_L2_EXPLORER_URL,
    },
  },
};

export const sen = {
  id: Number(process.env.REACT_APP___CHAIN2___L2_CHAIN_ID),
  name: "Sense IoT Blockchain",
  network: "Sense IoT Blockchain",
  iconUrl: "https://",
  iconBackground: "#000000",
  nativeCurrency: {
    decimals: 18,
    name: "SENSE",
    symbol: "SENSE",
  },
  rpcUrls: {
    default: {
      http: [process.env.REACT_APP___CHAIN2___L2_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: process.env.REACT_APP___CHAIN2___L2_EXPLORER_URL,
    },
  },
};

export const meta = {
  id: Number(process.env.REACT_APP___CHAIN3___L2_CHAIN_ID),
  name: "META Id Blockchain",
  network: "META Id Blockchain",
  iconUrl: "https://",
  iconBackground: "#000000",
  nativeCurrency: {
    decimals: 18,
    name: "META",
    symbol: "META",
  },
  rpcUrls: {
    default: {
      http: [process.env.REACT_APP___CHAIN3___L2_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "Block Explorer",
      url: process.env.REACT_APP___CHAIN3___L2_EXPLORER_URL,
    },
  },
};


const { chains, publicClient } = configureChains(
  [currentChain, sepolia, 
    jbc, pom, sen, meta
  ],
  [
    jsonRpcProvider({
      rpc: (chain) => ({ http: chain.rpcUrls.default.http[0] }),
    }),
  ],
);


export const connectors = [
  new MetaMaskConnector({
    chains,
    options: {
      shimDisconnect: false,
    },
  }),
];

const config = createConfig({
  autoConnect: true,
  connectors,
  storage: createStorage({ storage: window.localStorage }),
  publicClient,
});
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <WagmiConfig config={config}>
    <Provider store={store}>
      <App />
    </Provider>
    ,
  </WagmiConfig>,
);
reportWebVitals();
